import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionFeedbackUpdateInput } from '../generated/globalTypes';
import { updateQuestionFeedbackMutation, updateQuestionFeedbackMutationVariables } from '../generated/updateQuestionFeedbackMutation';
import { questionFeedbackFieldsFragment } from '../models/QuestionFeedback';

/**
 * Get a callback to update a QuestionFeedback in the store.
 */
export function useUpdateQuestionFeedbackCallback(): [(id: string, model: QuestionFeedbackUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateQuestionFeedbackMutation, updateQuestionFeedbackMutationVariables>(
        gql`
            mutation updateQuestionFeedbackMutation ($model: QuestionFeedbackUpdateInput!) {
                updateQuestionFeedback(model: $model) {
                    ...questionFeedbackFields
                }
            }

            ${questionFeedbackFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: QuestionFeedbackUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
